import { motion } from "framer-motion";
import { PackageSearch, Warehouse, Plane, FileCheck, Truck, CheckCircle2, Box } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { JOURNEY } from "@/lib/site-data";

const ICONS = { pickup: PackageSearch, warehouse: Warehouse, airport: Plane, customs: FileCheck, delivery: Truck, delivered: CheckCircle2 };

export default function ShipmentJourney() {
  return (
    <section id="journey" className="relative py-24 sm:py-32 bg-[#F5F5F7] border-y border-black/5 overflow-hidden">
      <div className="pointer-events-none absolute right-0 top-10 h-[360px] w-[360px] glow-purple" />
      <div className="relative mx-auto max-w-[1320px] px-5 sm:px-8">
        <Reveal>
          <div className="mb-4 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.22em] text-[#E31B23]">
            <span className="h-px w-8 bg-[#E31B23]" /> Live shipment journey
          </div>
          <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
            <h2 className="max-w-2xl font-display text-4xl font-extrabold leading-tight text-[#1F1F1F] sm:text-5xl">
              Follow your package, every step.
            </h2>
            <p className="max-w-sm text-[#4b5563]">
              From the moment we collect it to the second it's signed for — full visibility, in real time.
            </p>
          </div>
        </Reveal>

        {/* desktop rail */}
        <Reveal delay={0.1}>
          <div className="relative mt-16 hidden lg:block">
            <div className="absolute left-0 right-0 top-7 h-px bg-black/10" />
            <svg className="absolute left-0 right-0 top-7 h-px w-full" preserveAspectRatio="none" viewBox="0 0 100 1">
              <line x1="0" y1="0.5" x2="100" y2="0.5" stroke="#5A189A" strokeWidth="1" className="dash-flow" opacity="0.5" />
            </svg>
            {/* moving package */}
            <motion.div
              className="absolute -top-1 z-10"
              initial={{ left: "0%" }}
              animate={{ left: ["0%", "100%"] }}
              transition={{ duration: 9, repeat: Infinity, ease: "easeInOut", repeatType: "reverse" }}
            >
              <span className="flex h-9 w-9 -translate-x-1/2 items-center justify-center rounded-full bg-[#E31B23] shadow-[0_8px_20px_-6px_rgba(227,27,35,0.7)]">
                <Box size={16} className="text-white" />
              </span>
            </motion.div>

            <div className="relative grid grid-cols-6 gap-4">
              {JOURNEY.map((s, i) => {
                const Icon = ICONS[s.key];
                return (
                  <div key={s.key} className="flex flex-col items-center text-center" data-testid={`journey-${s.key}`}>
                    <span className="flex h-14 w-14 items-center justify-center rounded-2xl border border-black/5 bg-white shadow-[0_10px_24px_-16px_rgba(17,24,39,0.4)]">
                      <Icon size={22} className="text-[#5A189A]" />
                    </span>
                    <div className="mt-4 font-display text-base font-bold text-[#1F1F1F]">{s.title}</div>
                    <p className="mt-1 text-xs leading-relaxed text-[#4b5563] max-w-[9rem]">{s.desc}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </Reveal>

        {/* mobile stack */}
        <div className="mt-12 space-y-4 lg:hidden">
          {JOURNEY.map((s, i) => {
            const Icon = ICONS[s.key];
            return (
              <Reveal key={s.key} delay={i * 0.05}>
                <div className="flex items-center gap-4 rounded-2xl bg-white border border-black/5 p-4">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#5A189A]/10">
                    <Icon size={18} className="text-[#5A189A]" />
                  </span>
                  <div>
                    <div className="font-display text-base font-bold text-[#1F1F1F]">{s.title}</div>
                    <p className="text-xs text-[#4b5563]">{s.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
